module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/MY-d771069a9c2d8d1d82b0ca6ee2642d7f.png";